import React from 'react';

// ── Shared colors ───────────────────────────────────────────────────────────
const GREEN = 'var(--green-dark, #3D6B35)';

// Nudge shown once per session after login. The full RSVP now collects
// welcome-party attendance, wedding attendance, dinner selection, and dietary
// needs — so this modal just routes guests to the RSVP page rather than
// saving a partial response inline.
export default function RsvpModal({ onClose }) {
  const dismiss = () => {
    sessionStorage.setItem('ferry_rsvp_modal_dismissed', 'true');
    onClose();
  };

  const goToRsvp = () => {
    sessionStorage.setItem('ferry_rsvp_modal_dismissed', 'true');
    window.location.href = '/rsvp';
  };

  return (
    <div className="rsvp-modal-overlay" onClick={dismiss}>
      <div className="rsvp-modal" onClick={e => e.stopPropagation()}>

        {/* Mascot row */}
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '4px', marginBottom: '4px' }}>
          <img src="/Flamingo Pointing.jpeg" alt="Flamingo" style={{
            height: '70px', width: 'auto', objectFit: 'contain', mixBlendMode: 'multiply', filter: 'contrast(1.3)',
          }} />
          <div style={{
            fontSize: '2rem', fontFamily: 'var(--font-script)', color: GREEN, lineHeight: 1.2,
          }}>
            Kindly Reply
          </div>
          <img src="/Gator Pointing.jpeg" alt="Gator" style={{
            height: '70px', width: 'auto', objectFit: 'contain', mixBlendMode: 'multiply', filter: 'contrast(1.3)',
          }} />
        </div>

        <div style={{ fontSize: '0.9rem', color: 'grey', fontFamily: 'var(--font-script)', marginBottom: '20px' }}>
          October 30, 2026
        </div>

        <p style={{ fontSize: '0.88rem', color: '#374151', marginBottom: '10px', lineHeight: 1.5 }}>
          Have you had a chance to RSVP yet?
        </p>
        <p style={{ fontSize: '0.76rem', color: '#9ca3af', marginBottom: '24px', lineHeight: 1.5, fontStyle: 'italic' }}>
          We'll ask about the Welcome Party on Thursday, the Wedding on Friday,
          and your dinner selection — it only takes a minute.
        </p>

        <button onClick={goToRsvp} style={{
          width: '100%', padding: '14px', background: GREEN, color: 'white',
          border: 'none', borderRadius: '10px', fontSize: '0.95rem', fontWeight: '700',
          cursor: 'pointer', marginBottom: '12px', letterSpacing: '0.02em',
        }}>
          RSVP Now
        </button>
        <button onClick={dismiss} style={{
          width: '100%', padding: '12px', background: 'transparent', color: GREEN,
          border: `2px solid ${GREEN}`, borderRadius: '10px', fontSize: '0.88rem',
          fontWeight: '600', cursor: 'pointer', marginBottom: '12px',
        }}>
          RSVP Later
        </button>
        <button onClick={dismiss} style={{
          background: 'none', border: 'none', color: '#9ca3af',
          fontSize: '0.82rem', cursor: 'pointer', textDecoration: 'underline', padding: '4px',
        }}>
          Already Did!
        </button>

      </div>
    </div>
  );
}
